import { render, staticRenderFns } from "./ScipInformation.vue?vue&type=template&id=068111e4&"
import script from "./ScipInformation.vue?vue&type=script&lang=js&"
export * from "./ScipInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports